import { Button } from '@/components/ui/button';

export function ClickableCell({
  label,
  onClick,
}: {
  label: string;
  onClick: () => void;
}) {
  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-7 px-2 text-sm underline font-medium text-primary"
      onClick={onClick}
    >
      {label}
    </Button>
  );
}
